export default "__VITE_ASSET__DcerdTna__"